import {
  cyan700,
  pinkA200,
  grey100,
  grey300,
  grey400,
  grey500,
  grey800,
  white,
  darkBlack,
  fullBlack,
  transparent,
  red500,
  cyan500,
} from "material-ui/styles/colors";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import {darken, fade , lighten} from "material-ui/utils/colorManipulator";
import spacing from "material-ui/styles/spacing";
import typography from "material-ui/styles/typography";
//#173F4F
const palette = {
  primary1Color: cyan500,
    primary2Color: cyan700,
    primary3Color: grey400,
    accent1Color: pinkA200,
    accent2Color: grey100,
    accent3Color: grey500,
    textColor: darkBlack,
    secondaryTextColor: fade(darkBlack, 0.54),
    alternateTextColor: white,
    canvasColor: white,
    borderColor: grey300,
    disabledColor: fade(darkBlack, 0.3),
    pickerHeaderColor: cyan500,
    clockCircleColor: fade(darkBlack, 0.07),
    shadowColor: fullBlack,
};

export const muiTheme = getMuiTheme({
  spacing: spacing,
  // fontFamily: "Open Sans, san-serif",
  fontFamily: "Ubuntu, sans-serif",
  palette: palette,
  textField: {
    textColor: grey800,
    hintColor: palette.disabledColor,
    floatingLabelColor: palette.disabledColor,
    disabledTextColor: palette.disabledColor,
    errorColor: red500,
    focusColor: palette.primary1Color,
    backgroundColor: "transparent",
    borderColor: palette.borderColor
  },
  datePicker: {
      color: palette.primary1Color,
      textColor: palette.alternateTextColor,
      calendarTextColor: palette.textColor,
      selectColor: palette.primary2Color,
      selectTextColor: palette.alternateTextColor,
      calendarYearBackgroundColor: palette.canvasColor,
      headerColor: palette.pickerHeaderColor || palette.primary1Color,
    },
    table: {
        backgroundColor: palette.canvasColor,
      },
      tableFooter: {
        borderColor: palette.borderColor,
        textColor: palette.accent3Color,
      },
      tableHeader: {
        borderColor: palette.borderColor,
      },
      tableHeaderColumn: {
        textColor: palette.accent3Color,
        height: 56,
        spacing: 24,
      },
      tableRow: {
        hoverColor: palette.accent2Color,
        stripeColor: fade(lighten(palette.primary1Color, 0.5), 0.4),
        selectedColor: palette.borderColor,
        textColor: palette.textColor,
        borderColor: palette.borderColor,
        height: 48,
      },
      tableRowColumn: {
        height: 48,
        spacing: 24,
      },
      flatButton: {
        color: transparent,
        buttonFilterColor: '#999999',
        disabledTextColor: fade(palette.textColor, 0.3),
        textColor: palette.textColor,
        primaryTextColor: palette.primary1Color,
        secondaryTextColor: palette.accent1Color,
        fontSize: typography.fontStyleButtonFontSize,
        fontWeight: typography.fontWeightMedium,
      },
      raisedButton: {
        color: palette.alternateTextColor,
        textColor: palette.textColor,
        primaryColor: palette.primary1Color,
        primaryTextColor: palette.alternateTextColor,
        secondaryColor: palette.accent1Color,
        secondaryTextColor: palette.alternateTextColor,
        disabledColor: darken(palette.alternateTextColor, 0.1),
        disabledTextColor: fade(palette.textColor, 0.3),
        fontSize: typography.fontStyleButtonFontSize,
        fontWeight: typography.fontWeightMedium,
      },
});

// export default muiTheme;

export const rebassTheme = {
  breakpoints: [
    // min-width breakpoints in ems
    40,
    52,
    60
  ],
  space: [0, 6, 12, 18, 24, 30, 36],
  fontSizes: [12, 16, 18, 24, 36, 48, 72],
  // weights: [400, 600],
  weights: [300, 400],
  colors: { black: "#111", white: "#fff", blue: "#0ac" },
  // font: "Open Sans, san-serif",
  font: "Ubuntu, sans-serif",
  monospace: '"Roboto Mono", Menlo, monospace',
  radius: 2
};



// WEBPACK FOOTER //
// ./src/theme.js